export var UserPosition;
(function (UserPosition) {
    UserPosition["Acquisition"] = "Acquisition";
    UserPosition["Analytics"] = "Analytics";
    UserPosition["ContentCreation"] = "Content management";
    UserPosition["DataScience"] = "Data science";
    UserPosition["Marketing"] = "Marketing";
    UserPosition["Merchandiser"] = "Merchandising";
    UserPosition["Optimisation"] = "Optimisation / Performance";
    UserPosition["ProductManagement"] = "Product management";
    UserPosition["TopManagement"] = "Top management";
    UserPosition["ItAndSecurity"] = "Technical / IT / Security";
    UserPosition["Others"] = "Others";
    UserPosition["Support"] = "Support";
    UserPosition["UiUxDesign"] = "UI / UX Design";
    UserPosition["BusinessIntelligence"] = "Business Intelligence";
    UserPosition["CustomerSuccess"] = "Customer Success";
    UserPosition["CustomerSuccessManager"] = "Customer Success Manager";
    UserPosition["CustomerEnablementManager"] = "Customer Enablement Manager";
    UserPosition["DataAnalyst"] = "Data Analyst";
    UserPosition["Finance"] = "Finance";
    UserPosition["GlobalServices"] = "Global Services";
    UserPosition["Implementation"] = "Implementation";
    UserPosition["Legal"] = "Legal";
    UserPosition["Operations"] = "Operations";
    UserPosition["People"] = "People";
    UserPosition["Product"] = "Product";
    UserPosition["ProductExperienceManager"] = "Product Experience Manager";
    UserPosition["ResearchAndDevelopment"] = "R&D";
    UserPosition["Sales"] = "Sales";
})(UserPosition || (UserPosition = {}));
export const CUSTOMER_JOB_POSITION = [
    { label: 'Acquisition (Acquisition manager, Paid search manager, SEO manager…)', value: UserPosition.Acquisition },
    { label: 'Analytics (Data analyst, Business analyst, Business intelligence…)', value: UserPosition.Analytics },
    { label: 'Content management (Content creator, UI designer…)', value: UserPosition.ContentCreation },
    { label: 'Data science (Data analyst, Data scientists…)', value: UserPosition.DataScience },
    { label: 'Marketing (Community manager…)', value: UserPosition.Marketing },
    { label: 'Merchandising (Category manager, Merchandiser, Pricer…)', value: UserPosition.Merchandiser },
    {
        label: 'Optimisation / Performance (Chief conversion officer, Ecommerce manager…)',
        value: UserPosition.Optimisation,
    },
    {
        label: 'Product management (Product owner, Product manager, Project manager…)',
        value: UserPosition.ProductManagement,
    },
    { label: 'Technical / IT / Security (Developper, Software engineer…)', value: UserPosition.ItAndSecurity },
    { label: 'Support', value: UserPosition.Support },
    { label: 'UX design (UX designer…)', value: UserPosition.UiUxDesign },
    { label: 'Top management (VPs C-suite...)', value: UserPosition.TopManagement },
    { label: 'Others', value: UserPosition.Others },
];
export const EMPLOYEE_JOB_POSITION = [
    { label: 'Business Intelligence', value: UserPosition.BusinessIntelligence },
    { label: 'Customer Success', value: UserPosition.CustomerSuccess },
    { label: 'Customer Success Manager', value: UserPosition.CustomerSuccessManager },
    { label: 'Customer Enablement Manager', value: UserPosition.CustomerEnablementManager },
    { label: 'Data Analyst', value: UserPosition.DataAnalyst },
    { label: 'Finance', value: UserPosition.Finance },
    { label: 'Global Services', value: UserPosition.GlobalServices },
    { label: 'Implementation', value: UserPosition.Implementation },
    { label: 'Technical / IT / Security', value: UserPosition.ItAndSecurity },
    { label: 'Legal', value: UserPosition.Legal },
    { label: 'Operations', value: UserPosition.Operations },
    { label: 'Others', value: UserPosition.Others },
    { label: 'People', value: UserPosition.People },
    { label: 'Product', value: UserPosition.Product },
    { label: 'Product Experience Manager', value: UserPosition.ProductExperienceManager },
    { label: 'R&D', value: UserPosition.ResearchAndDevelopment },
    { label: 'Sales', value: UserPosition.Sales },
    { label: 'Support', value: UserPosition.Support },
    { label: 'UI / UX Design', value: UserPosition.UiUxDesign },
];
//# sourceMappingURL=user-position.js.map